// src/components/WelcomePopup.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const WelcomePopup = () => {
  const [visible, setVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('fifa_ea26_welcome_seen');
    
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setVisible(true);
        setTimeout(() => setIsVisible(true), 100);
        localStorage.setItem('fifa_ea26_welcome_seen', 'true');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => setVisible(false), 500);
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      centered
      width={700}
      closable={false}
      maskClosable={true}
      style={{
        top: '50%',
        transform: 'translateY(-50%)',
      }}
      bodyStyle={{
        padding: 0,
        background: 'linear-gradient(135deg, #001489 0%, #0033a0 25%, #0056b3 50%, #007acc 75%, #0099e6 100%)',
        borderRadius: '20px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Background animé avec des éléments FIFA */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(255, 215, 0, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(0, 255, 255, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 40% 40%, rgba(255, 107, 0, 0.08) 0%, transparent 50%)
        `,
        zIndex: 1,
      }}></div>

      {/* Animation de particules */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255, 255, 255, 0.05) 10px, rgba(255, 255, 255, 0.05) 20px)
        `,
        animation: 'slideBackground 20s linear infinite',
        zIndex: 2,
      }}></div>

      {/* Contenu principal */}
      <div style={{
        position: 'relative',
        zIndex: 3,
        padding: '40px',
        textAlign: 'center',
        color: 'white',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      }}>
        
        {/* Logo FIFA animé */}
        <div style={{
          marginBottom: '30px',
          animation: 'bounce 2s infinite ease-in-out',
        }}>
          <div style={{
            fontSize: '60px',
            fontWeight: 'bold',
            background: 'linear-gradient(45deg, #ffd700, #ff6b00, #00ffff)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 0 30px rgba(255, 215, 0, 0.5)',
            filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.3))',
          }}>
            ⚽🎮
          </div>
        </div>

        <Title level={1} style={{ 
          color: 'white',
          marginBottom: '15px',
          fontWeight: 'bold',
          textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
          fontSize: '2.5rem',
          background: 'linear-gradient(45deg, #ffd700, #ff6b00)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}>
          🎉 BIENVENUE DANS FIFA EA SPORTS 26! 🎉
        </Title>

        <Text style={{ 
          fontSize: '1.2rem', 
          display: 'block', 
          marginBottom: '30px',
          color: '#ffffffcc',
          textShadow: '1px 1px 4px rgba(0,0,0,0.5)',
        }}>
          L'expérience de gaming ultime vous attend!
        </Text>

        <Space direction="vertical" size="large" style={{ 
          textAlign: 'left', 
          margin: '30px 0',
          width: '100%'
        }}>
          <div>
            <Text strong style={{ 
              color: '#ffd700', 
              fontSize: '1.1rem',
              display: 'block',
              marginBottom: '10px',
              textShadow: '0 0 10px rgba(255, 215, 0, 0.5)'
            }}>
              ⚽ NOUVEAUTÉS EXCLUSIVES 2026:
            </Text>
            <ul style={{ 
              margin: '12px 0', 
              paddingLeft: '25px',
              color: '#ffffffdd',
              fontSize: '1rem',
              listStyle: 'none'
            }}>
              {['Graphismes next-gen révolutionnaires', 'Mode carrière entièrement repensé', 'Gameplay ultra-réaliste', 'Stades et équipes exclusives'].map((item, index) => (
                <li key={index} style={{ 
                  marginBottom: '8px',
                  paddingLeft: '20px',
                  position: 'relative',
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? 'translateX(0)' : 'translateX(-20px)',
                  transition: `all 0.6s ease-out ${index * 0.1}s`
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#ff6b00'
                  }}>•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <Text strong style={{ 
              color: '#00ffff', 
              fontSize: '1.1rem',
              display: 'block',
              marginBottom: '10px',
              textShadow: '0 0 10px rgba(0, 255, 255, 0.5)'
            }}>
              🎮 AVANTAGES IMMÉDIATS:
            </Text>
            <ul style={{ 
              margin: '12px 0', 
              paddingLeft: '25px',
              color: '#ffffffdd',
              fontSize: '1rem',
              listStyle: 'none'
            }}>
              {['Meilleures offres du marché', 'Comptes FIFA premium', 'Support technique 24/7', 'Transactions sécurisées'].map((item, index) => (
                <li key={index} style={{ 
                  marginBottom: '8px',
                  paddingLeft: '20px',
                  position: 'relative',
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? 'translateX(0)' : 'translateX(-20px)',
                  transition: `all 0.6s ease-out ${0.4 + index * 0.1}s`
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#00ffff'
                  }}>•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Space>

        <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleClose}
          size="large"
          style={{
            background: 'linear-gradient(45deg, #ff6b00, #ffd700)',
            border: 'none',
            fontWeight: 'bold',
            padding: '15px 40px',
            fontSize: '1.1rem',
            borderRadius: '50px',
            marginTop: '30px',
            boxShadow: '0 4px 15px rgba(255, 107, 0, 0.4)',
            transition: 'all 0.3s ease',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'scale(1)' : 'scale(0.8)',
            transitionDelay: '0.8s'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 6px 20px rgba(255, 107, 0, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 0, 0.4)';
          }}
        >
          Découvrir FIFA EA 26 !
        </Button>

        <Text style={{ 
          display: 'block', 
          marginTop: '25px', 
          fontStyle: 'italic',
          color: '#ffffff99',
          fontSize: '0.9rem'
        }}>
          Des milliers de joueurs nous font déjà confiance. Rejoignez l'aventure !
        </Text>
      </div>

      {/* Styles CSS inline pour les animations */}
      <style>
        {`
          @keyframes slideBackground {
            0% { background-position: 0 0; }
            100% { background-position: 100% 100%; }
          }
          
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>
    </Modal>
  );
};

export default WelcomePopup;